import type { HTMLAttributes } from 'react';

import { cn } from '../../lib/utils';
import { TovCard } from '../TovCard/TovCard';

export function PageGrid({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('page-grid', className)} {...props} />;
}

export function PageCard({
  className,
  wide = false,
  ...props
}: HTMLAttributes<HTMLElement> & {
  wide?: boolean;
}) {
  return (
    <TovCard variant="content" className={className} isWide={wide} {...props} />
  );
}

export function PageWideSection({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return <TovCard variant="content" className={className} isWide {...props} />;
}

export function PageHero({
  className,
  wide = true,
  ...props
}: HTMLAttributes<HTMLElement> & {
  wide?: boolean;
}) {
  return (
    <TovCard
      variant="content"
      className={cn('hero-card', className)}
      isWide={wide}
      {...props}
    />
  );
}

export function PageEyebrow({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('page-eyebrow', className)} {...props} />;
}

export function DetailList({
  className,
  stacked = false,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  stacked?: boolean;
}) {
  return (
    <div
      className={cn(
        'detail-list',
        stacked && 'detail-list--stacked',
        className,
      )}
      {...props}
    />
  );
}

export function ActionRow({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('action-row', className)} {...props} />;
}

export function HeroStats({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('hero-card__stats', className)} {...props} />;
}
